module.exports = __webpack_public_path__ + "static/media/internetveloce-card.c19a681f.png";